import {
  CellContext,
  createColumnHelper
} from "@tanstack/react-table";

import { IPendingCustomer } from "src/core/pending-customers/api/pendingCustomer.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";

import { pendingCustomerStatusColumn } from "./pendingCustomerStatusColumn";
import { pendingCustomerAssignedColumn } from "./pendingCustomerAssignedColumn";

export const pendingCustomersTableColumns = (actionButton: (info: CellContext<IPendingCustomer, unknown>) => React.ReactNode) => {
  const customColumnHelper = customCreateColumnHelper<IPendingCustomer>();
  const columnHelper = createColumnHelper<IPendingCustomer>();

  return [
    customColumnHelper.standardTextColumn(columnHelper, "name", { header: "Business" }),
    pendingCustomerAssignedColumn(columnHelper, { header: "Assigned" }),
    customColumnHelper.standardTextColumn(columnHelper, "contactName", { header: "Contact" }),
    customColumnHelper.standardTextColumn(columnHelper, "contactEmail", { header: "Email" }),
    customColumnHelper.standardTextColumn(columnHelper, "address.addressLine1", { header: "Address" }),
    pendingCustomerStatusColumn(columnHelper, {}),
    customColumnHelper.dateColumn(columnHelper, "createdAt", {
      header: "Created",
      format: "D MMM YYYY"
    }),
    customColumnHelper.dateColumn(columnHelper, "updatedAt", {
      header: "Updated",
      format: "D MMM YYYY"
    }),
    customColumnHelper.actionColumn(columnHelper, actionButton, { size: 180 })
  ];
};
